import type { ReadonlyURLSearchParams } from 'next/navigation';

import { Toaster } from '~features/toaster';

import { QUERY_PROMOCODE_PARAM_NAME } from '../const';
import { saveDefaultPromocode } from '../promocode-storage';

const copyPromocodeToClipboard = async (text: string) => {
	try {
		await navigator?.clipboard?.writeText(text);
		Toaster.showSuccess({
			titleKey: 'promocodeCopiedTitle',
			delay: 1000,
			autoClose: 6000,
			toastId: 'promocode-copied',
		});
	} catch {
		Toaster.showSuccess({
			titleKey: 'promocodeCopiedApplied',
			delay: 1000,
			autoClose: 6000,
			toastId: 'promocode-copied',
		});
	}
};

export const handlePromocodeFromQuery = (
	query: ReadonlyURLSearchParams | URLSearchParams
) => {
	if (query.has(QUERY_PROMOCODE_PARAM_NAME)) {
		const promocode = query.get(QUERY_PROMOCODE_PARAM_NAME);
		if (!promocode) return;
		void copyPromocodeToClipboard(promocode);
		saveDefaultPromocode(promocode);
	}
};
